import { h, Component } from 'preact';
import PropTypes from 'prop-types';

import DirectSalesForm from './DirectSalesForm';

export default class DirectSalesFormApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmittingForm: false,
      errorSendingForm: false,
      showOverlay: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCloseOverlay = this.handleCloseOverlay.bind(this);
  }

  handleCloseOverlay() {
    this.setState({ showOverlay: false });

    const { link } = this.props;
    const { errorSendingForm } = this.state;

    if (link && !errorSendingForm) {
      window.open(link, '_self');
    }
  }

  handleSubmit(e, params) {
    this.setState({ isSubmittingForm: true });

    return serviceConversion
      .convert(params)
      .then(() => {
        this.setState({
          isSubmittingForm: false,
          errorSendingForm: false
        });
      })
      .catch(error => {
        this.setState({
          isSubmittingForm: false,
          errorSendingForm: true
        });
        console.error(error);
      })
      .then(() => {
        this.setState({
          showOverlay: true
        });
      });
  }

  render() {
    const { formId, product, channel, category } = this.props;
    return (
      <DirectSalesForm
        formId={formId}
        handleSubmit={this.handleSubmit}
        isSubmittingForm={this.state.isSubmittingForm}
        errorSendingForm={this.state.errorSendingForm}
        handleCloseOverlay={this.handleCloseOverlay}
        showOverlay={this.state.showOverlay}
        product={product}
        channel={channel}
        category={category}
        brand={this.props.brand}
        units={this.props.units}
        showUnits={this.props.showUnits}
        showCpf={this.props.showCpf}
        shouldShowDataPermissions={this.props.shouldShowDataPermissions}
        dataPermissionsCustomText={this.props.dataPermissionsCustomText}
        linkPrivacyPolicy={this.props.linkPrivacyPolicy}
        versions={this.props.versions}
      />
    );
  }
}

DirectSalesFormApp.defaultProps = {
  formId: 'showcase-direct-sales-no-offer-form-modal',
  brand: '-',
  units: [],
  product: 'Direct Sale',
  category: 'DirectSale',
  showUnits: true,
  showCpf: false,
  shouldShowDataPermissions: false,
};

DirectSalesFormApp.propTypes = {
  formId: PropTypes.string,
  product: PropTypes.string,
  channel: PropTypes.string,
  category: PropTypes.string,
  brand: PropTypes.string,
  units: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  showUnits: PropTypes.bool,
  showCpf: PropTypes.bool,
  shouldShowDataPermissions: PropTypes.bool,
  dataPermissionsCustomText: PropTypes.string,
};
